var gdprDetails = {
		emailIn: $('.update-form #Email'),
		mobileIn: $('.update-form #Mobile'),
		addressFirstLine: $('.update-form #AddressLine1'),
		addressSecondLine: $('.update-form #AddressLine2'),
		addressCity: $('.update-form #City'),
		stateToggle: $('.state-toggle'),

	generic: function() {
		var checkerItems = [gdprDetails.emailIn, gdprDetails.mobileIn, gdprDetails.addressFirstLine, gdprDetails.addressSecondLine, gdprDetails.addressCity];

		for (var i = 0; i < checkerItems.length; i++) {

			gdprDetails.checkInputField(checkerItems[i]);
		}
		gdprDetails.locationToggle();
		gdprDetails.locationDependentChecker();


		//$('.save-changes').on('click', gdprDetails.saveChangesGDPR);
	},


	// saveChangesGDPR: function(){
	// 	var checkerItems = [gdprDetails.emailIn, gdprDetails.mobileIn, gdprDetails.addressFirstLine, gdprDetails.addressCity];
  //
	// 	for (var i = 0; i < checkerItems.length; i++) {
  //
	// 		gdprDetails.checkInputField(checkerItems[i]);
	// 	}
	// 	gdprDetails.checkLocationStatus();
	// },

	// checkLocationStatus: function(){
	// 	if($('.gdpr-pref-item.Mobile').hasClass('is-empty') && $('.gdpr-pref-item.Email').hasClass('is-empty')){
  //
	// 		$('.gdpr-pref-item.location').addClass('is-empty');
	// 		gdprDetails.locationStatus('no');
	// 	} else {
  //
	// 		gdprDetails.locationStatus('yes');
	// 	}
	// },

	locationToggle: function(){
		gdprDetails.stateToggle.on('click', function(e){
			e.preventDefault();
		});
	},

	locationAllowed: function(){
		gdprDetails.stateToggle.addClass('allowed');
		gdprDetails.stateToggle.removeClass('not-allowed');
		gdprDetails.stateToggle.attr('data-inputVal', 'true');
		gdprModal.hiddenInputVal(gdprDetails.stateToggle);
	},

	locationDependentChecker: function(){
		if($('#MobileDependancyCheck').length > 0){
			var mobileCheckVal = $('#MobileDependancyCheck').attr('value').toLowerCase(),
					emailCheckVal = $('#EmailDependancyCheck').attr('value').toLowerCase();
			if (mobileCheckVal === 'false' && emailCheckVal === 'false'){
				gdprDetails.locationNotAllowed();
			}

		}

	},

	locationNotAllowed: function(){
		gdprDetails.stateToggle.removeClass('allowed');
		gdprDetails.stateToggle.addClass('not-allowed');
		gdprDetails.stateToggle.attr('data-inputVal', 'false');
		gdprModal.hiddenInputVal(gdprDetails.stateToggle);
	},

	locationStatus: function(ls){
		if(ls === 'yes') {
			gdprDetails.stateToggle.parents('.gdpr-pref-item').removeClass('is-empty');
		} else {
			gdprDetails.locationNotAllowed();
		}
	},

	checkInputField: function(inputItem){
		var inputVal = inputItem.val(),
				inputId = inputItem.attr('id');

		if (inputId === 'AddressLine1' || inputId === 'City'){
			var addressVal = gdprDetails.addressFirstLine.val(),
					addressVal2 = gdprDetails.addressSecondLine.val(),
					cityVal = gdprDetails.addressCity.val();

			if(addressVal === '' || cityVal === ''){
				$('.gdpr-pref-item.post').addClass('is-empty');
			} else {
				$('.gdpr-pref-item.post').removeClass('is-empty');
			}
		} else {
			if(inputVal === ''){
				$('.gdpr-pref-item.' + inputId).addClass('is-empty');
				$('.gdpr-pref-item.' + inputId).find('input').prop('checked', false);
			} else {
				$('.gdpr-pref-item.' + inputId).removeClass('is-empty');
			}
		}

		inputItem.on('change', function(){
			var thisId = $(this).attr('id');
			if(thisId === 'AddressLine1' || thisId === 'City'){
				var addressVal = gdprDetails.addressFirstLine.val(),
						cityVal = gdprDetails.addressCity.val();
				if(addressVal === '' || cityVal === ''){
					// console.log('One is empty:', addressVal, cityVal);
					$('.gdpr-pref-item.post').addClass('is-empty');
					$('.gdpr-pref-item.post').find('input').prop('checked', false);
					$('#PostOptIn').attr('checked', false);
				} else {
					$('.gdpr-pref-item.post').removeClass('is-empty');
				}
			} else {
				if($(this).val() === ''){
					$('.gdpr-pref-item.' + thisId).addClass('is-empty');
					$('.gdpr-pref-item.' + thisId).find('input').prop('checked', false);
				} else {
					$('.gdpr-pref-item.' + thisId).removeClass('is-empty');
				}
			}
			//gdprDetails.checkLocationStatus();
		});
		//gdprDetails.checkLocationStatus();
	},

	init: function() {
		if($('.gdpr-new-pref').length > 0){
			gdprDetails.generic();
		}

	}
};
